export * from 'server/models/ReservationsDashboardResponse';


// WEBPACK FOOTER //
// ./data/models/ReservationsDashboardResponse.ts